
import Vue from 'vue';
import QoalaTyped from '../../Icons/QoalaTyped.vue';
import NotificationIcon from '../../Icons/NotificationIcon.vue';
import QoalaButton from '../Button/Button.vue';
import { Padder } from '../Spacings';
import { Row } from '../Grid';
import ArrowLeftIcon from '../../Icons/ArrowLeftIcon.vue';
import Token from '../Token';

/**
 * The Header of the Application with Sign-in / Registration button.
 *
 * This template consist of:
 *
 * - Menu icon / Back icon
 * - Logo
 * - Button Sign-in / Registration
 */
export default Vue.extend({
  name: 'AppBarSignIn',
  components: {
    QoalaTyped,
    ArrowLeftIcon,
    NotificationIcon,
    Padder,
    QoalaButton,
    Row
  },
  props: {
    /**
     * The logo of the AppBar.<br />
     * The type is VueComponent.
     */
    logo: {
      type: Object,
      default: () => {}
    },
    /**
     * Label for sign-in / registration button.
     */
    buttonRegistrationLabel: {
      type: String,
      default: 'Daftar'
    },
    /**
     * Toggle menu icon to arrow back icon.<br />
     * `true` is menu icon, `false` is back icon.
     */
    backNavigation: {
      type: Boolean,
      default: false
    },
    /**
     * Hiding the sign-in / registration button.
     */
    hideRegistration: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleNavigateBack() {
      /**
       * Handle when user click back icon.
       * @event back
       * @type {function}
       */
      this.$emit('back');
    },
    handleMenuClick() {
      /**
       * Handle when user click the menu.
       * @event menu-click
       * @type {function}
       */
      this.$emit('menu-click');
    },
    handleRegisterClick() {
      /**
       * Handle when user click the sign-in / register button.
       * @event register-click
       * @type {function}
       */
      this.$emit('register-click');
    }
  },
  computed: {
    arrowBackColor() {
      return Token.colors.uiOrangePrimary;
    }
  }
});
